import { addBreadcrumb } from '@sentry/react';
import { auth } from 'services/firebase';
import { getFirebaseErrorCode } from 'utils/firebase-error-checks';

export type AuthEventType =
  'logout' | 'session-reset' | 'refresh-auth-failed-transient' | 'refresh-auth-failed-permanent';

export type AuthEventContext = {
  source: string;
  reason: string;
  withRedirect?: boolean;
  operationKind?: string;
  operationKey?: number;
  errorMessage?: string;
  errorCode?: string;
};

const getAuthSnapshot = () => ({
  navigatorOnLine: navigator.onLine,
  hasCurrentUser: !!auth.currentUser,
  currentUserUid: auth.currentUser?.uid ?? null,
});

export const recordAuthEvent = (type: AuthEventType, context: AuthEventContext) => {
  const level = type === 'refresh-auth-failed-transient' ? 'warning' : type === 'logout' ? 'error' : 'info';

  addBreadcrumb({
    category: 'auth',
    message: `${type}: ${context.source}`,
    level,
    data: {
      ...context,
      ...getAuthSnapshot(),
    },
  });

  if (process.env.NODE_ENV !== 'production') {
    console.warn('[Auth]', type, context, getAuthSnapshot());
  }
};

export const getAuthErrorDetails = (error: unknown) => ({
  errorCode: getFirebaseErrorCode(error),
  errorMessage: error instanceof Error ? error.message : String(error),
});
